<template>
  <warehousing-in-stack lob="RE" />
</template>

<script>
import WarehousingInStack from '@/components/Cargo/Warehouse/warehousingInStack'
export default {
  name: 'REWarehousing',
  components: { WarehousingInStack }
}
</script>

<style scoped>

</style>
